import React, { useState, useEffect } from 'react';
import axiosInstance from '../api/axios';
import './AdminPage.css';
import logo from '../assets/teesergolf-logo.png';
import Navigation from '../components/Navigation';

// Tool options based on existing database values
const TOOL_OPTIONS = [
  { value: 'ezlinks', label: 'EZLinks' },
  { value: 'foreup', label: 'ForeUp' },
  { value: 'chrono', label: 'Chrono' },
  { value: 'prophet', label: 'Prophet' },
  { value: 'nbc', label: 'NBC' },
  { value: 'ezlink', label: 'EZLink' }
];

// Common US timezone options
const TIMEZONE_OPTIONS = [
  { value: '', label: 'Select timezone' },
  { value: 'America/New_York', label: 'Eastern' },
  { value: 'America/Chicago', label: 'Central' },
  { value: 'America/Denver', label: 'Mountain' },
  { value: 'America/Phoenix', label: 'Arizona' },
  { value: 'America/Los_Angeles', label: 'Pacific' },
  { value: 'America/Anchorage', label: 'Alaska' },
  { value: 'Pacific/Honolulu', label: 'Hawaii' }
];

// US State codes
const STATE_OPTIONS = [
  { value: '', label: 'Select state' },
  { value: 'AL', label: 'AL' }, { value: 'AK', label: 'AK' },
  { value: 'AZ', label: 'AZ' }, { value: 'AR', label: 'AR' },
  { value: 'CA', label: 'CA' }, { value: 'CO', label: 'CO' },
  { value: 'CT', label: 'CT' }, { value: 'DE', label: 'DE' },
  { value: 'FL', label: 'FL' }, { value: 'GA', label: 'GA' },
  { value: 'HI', label: 'HI' }, { value: 'ID', label: 'ID' },
  { value: 'IL', label: 'IL' }, { value: 'IN', label: 'IN' },
  { value: 'IA', label: 'IA' }, { value: 'KS', label: 'KS' },
  { value: 'KY', label: 'KY' }, { value: 'LA', label: 'LA' },
  { value: 'ME', label: 'ME' }, { value: 'MD', label: 'MD' },
  { value: 'MA', label: 'MA' }, { value: 'MI', label: 'MI' },
  { value: 'MN', label: 'MN' }, { value: 'MS', label: 'MS' },
  { value: 'MO', label: 'MO' }, { value: 'MT', label: 'MT' },
  { value: 'NE', label: 'NE' }, { value: 'NV', label: 'NV' },
  { value: 'NH', label: 'NH' }, { value: 'NJ', label: 'NJ' },
  { value: 'NM', label: 'NM' }, { value: 'NY', label: 'NY' },
  { value: 'NC', label: 'NC' }, { value: 'ND', label: 'ND' },
  { value: 'OH', label: 'OH' }, { value: 'OK', label: 'OK' },
  { value: 'OR', label: 'OR' }, { value: 'PA', label: 'PA' },
  { value: 'RI', label: 'RI' }, { value: 'SC', label: 'SC' },
  { value: 'SD', label: 'SD' }, { value: 'TN', label: 'TN' },
  { value: 'TX', label: 'TX' }, { value: 'UT', label: 'UT' },
  { value: 'VT', label: 'VT' }, { value: 'VA', label: 'VA' },
  { value: 'WA', label: 'WA' }, { value: 'WV', label: 'WV' },
  { value: 'WI', label: 'WI' }, { value: 'WY', label: 'WY' },
  { value: 'DC', label: 'DC' }
];

const initialFormState = {
  courseId: '',
  name: '',
  tool: '',
  alias: '',
  externalId: '',
  stateCode: '',
  url: '',
  bookingUrl: '',
  timezone: '',
  affiliation: ''
};

const parseCurlForTool = (curlString, tool) => {
  const urlMatch = curlString.match(/curl\s+['"]([^'"]+)['"]/);
  if (!urlMatch) return null;

  let urlObj;
  try {
    urlObj = new URL(urlMatch[1]);
  } catch {
    return null;
  }

  const baseUrl = `${urlObj.protocol}//${urlObj.hostname}${urlObj.pathname}`;

  const headers = {};
  for (const m of curlString.matchAll(/-H\s+['"]([^:'"]+):\s*([^'"]+)['"]/g)) {
    headers[m[1].toLowerCase().trim()] = m[2].trim();
  }

  let body = null;
  const bodyMatch =
    curlString.match(/(?:--data-raw|--data|-d)\s+'([^']*)'/) ||
    curlString.match(/(?:--data-raw|--data|-d)\s+"([^"]*)"/);
  if (bodyMatch) {
    try { body = JSON.parse(bodyMatch[1]); } catch { /* ignore */ }
  }

  const result = {};

  switch (tool) {
    case 'foreup': {
      result.url = baseUrl;
      const scheduleId = urlObj.searchParams.get('schedule_id');
      if (scheduleId) result.externalId = scheduleId;
      const bookingClass = urlObj.searchParams.get('booking_class');
      if (bookingClass && bookingClass !== 'false') result.affiliation = bookingClass;
      break;
    }
    case 'chrono': {
      result.url = baseUrl;
      const courseId = urlObj.searchParams.get('course_id');
      if (courseId) result.externalId = courseId;
      const affiliation = urlObj.searchParams.get('affiliation_type_ids[]');
      if (affiliation) result.affiliation = affiliation;
      break;
    }
    case 'ezlinks':
    case 'ezlink': {
      result.url = baseUrl;
      if (body?.p01) {
        result.externalId = Array.isArray(body.p01) ? body.p01.join(',') : String(body.p01);
      }
      const originHeader = headers['origin'] || '';
      const domainMatch = originHeader.match(/https?:\/\/([^.]+)\.ezlinksgolf\.com/);
      if (domainMatch) result.alias = domainMatch[1];
      break;
    }
    case 'nbc': {
      result.url = baseUrl;
      const facilityIds = urlObj.searchParams.get('facilityIds');
      if (facilityIds) result.externalId = facilityIds;
      const xBeAlias = headers['x-be-alias'];
      if (xBeAlias) result.alias = xBeAlias;
      break;
    }
    case 'prophet': {
      result.url = `${urlObj.protocol}//${urlObj.hostname}`;
      const courseId =
        urlObj.searchParams.get('CourseId') ||
        urlObj.searchParams.get('courseId') ||
        urlObj.searchParams.get('courseid');
      if (courseId) result.externalId = courseId;
      result.alias = urlObj.hostname;
      break;
    }
    default:
      break;
  }

  return Object.keys(result).length > 0 ? result : null;
};

function AdminPage() {
  // Tab state
  const [activeTab, setActiveTab] = useState('manage');

  // Add Course form state
  const [formData, setFormData] = useState(initialFormState);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState('');
  const [successMessage, setSuccessMessage] = useState('');

  // Course management state
  const [courses, setCourses] = useState([]);
  const [isLoadingCourses, setIsLoadingCourses] = useState(false);
  const [coursesError, setCoursesError] = useState('');
  const [coursesSuccess, setCoursesSuccess] = useState('');

  // Filter state
  const [filters, setFilters] = useState({
    search: '',
    tool: '',
    stateCode: '',
    active: ''
  });

  // cURL import state
  const [curlInput, setCurlInput] = useState('');
  const [curlError, setCurlError] = useState('');
  const [curlSuccess, setCurlSuccess] = useState('');

  const handleCurlExtract = () => {
    setCurlError('');
    setCurlSuccess('');
    if (!formData.tool) {
      setCurlError('Select a booking tool first.');
      return;
    }
    if (!curlInput.trim()) {
      setCurlError('Paste a cURL command first.');
      return;
    }
    const parsed = parseCurlForTool(curlInput, formData.tool);
    if (!parsed) {
      setCurlError('Could not parse the cURL command. Make sure the URL is valid.');
      return;
    }
    setFormData(prev => ({ ...prev, ...parsed }));
    const filled = Object.keys(parsed).join(', ');
    setCurlSuccess(`Auto-filled: ${filled}`);
    setTimeout(() => setCurlSuccess(''), 4000);
  };

  // Edit state
  const [editingCourseId, setEditingCourseId] = useState(null);
  const [editedCourses, setEditedCourses] = useState({});
  const [savingCourseId, setSavingCourseId] = useState(null);

  // Fetch courses on mount and when tab changes to manage
  useEffect(() => {
    if (activeTab === 'manage') {
      fetchCourses();
    }
  }, [activeTab]);

  const fetchCourses = async () => {
    setIsLoadingCourses(true);
    setCoursesError('');
    try {
      const response = await axiosInstance.get('/admin/courses');
      setCourses(response.data);
    } catch (err) {
      console.error('Error fetching courses:', err);
      setCoursesError('Failed to load courses. Please try again.');
    } finally {
      setIsLoadingCourses(false);
    }
  };

  // Filter courses
  const filteredCourses = courses.filter(course => {
    const searchLower = filters.search.toLowerCase();
    const matchesSearch = !filters.search ||
      course.name?.toLowerCase().includes(searchLower) ||
      course.courseId?.toLowerCase().includes(searchLower) ||
      course.alias?.toLowerCase().includes(searchLower);
    const matchesTool = !filters.tool || course.tool === filters.tool;
    const matchesState = !filters.stateCode || course.stateCode === filters.stateCode;
    const matchesActive = filters.active === '' ||
      (filters.active === 'true' && course.active) ||
      (filters.active === 'false' && !course.active);

    return matchesSearch && matchesTool && matchesState && matchesActive;
  });

  // Handle filter changes
  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters(prev => ({ ...prev, [name]: value }));
  };

  const clearFilters = () => {
    setFilters({ search: '', tool: '', stateCode: '', active: '' });
  };

  // Edit handling
  const startEditing = (course) => {
    setEditingCourseId(course.courseId);
    setEditedCourses(prev => ({
      ...prev,
      [course.courseId]: { ...course }
    }));
  };

  const cancelEditing = (courseId) => {
    setEditingCourseId(null);
    setEditedCourses(prev => {
      const updated = { ...prev };
      delete updated[courseId];
      return updated;
    });
  };

  const handleEditChange = (courseId, field, value) => {
    setEditedCourses(prev => ({
      ...prev,
      [courseId]: {
        ...prev[courseId],
        [field]: value
      }
    }));
  };

  const saveEdit = async (courseId) => {
    setSavingCourseId(courseId);
    setCoursesError('');
    setCoursesSuccess('');

    try {
      const editedCourse = editedCourses[courseId];
      await axiosInstance.put(`/admin/courses/${courseId}`, editedCourse);

      // Update local state
      setCourses(prev => prev.map(c =>
        c.courseId === courseId ? editedCourse : c
      ));

      setEditingCourseId(null);
      setEditedCourses(prev => {
        const updated = { ...prev };
        delete updated[courseId];
        return updated;
      });
      setCoursesSuccess(`Course "${editedCourse.name}" updated successfully!`);
      setTimeout(() => setCoursesSuccess(''), 3000);
    } catch (err) {
      console.error('Error saving course:', err);
      setCoursesError(err.response?.data?.message || 'Failed to save course. Please try again.');
    } finally {
      setSavingCourseId(null);
    }
  };

  const toggleCourseActive = async (course) => {
    setCoursesError('');
    setCoursesSuccess('');

    try {
      await axiosInstance.patch(`/admin/courses/${course.courseId}/toggle`);

      // Update local state
      setCourses(prev => prev.map(c =>
        c.courseId === course.courseId ? { ...c, active: !c.active } : c
      ));

      setCoursesSuccess(`Course "${course.name}" ${course.active ? 'deactivated' : 'activated'} successfully!`);
      setTimeout(() => setCoursesSuccess(''), 3000);
    } catch (err) {
      console.error('Error toggling course:', err);
      setCoursesError(err.response?.data?.message || 'Failed to toggle course status. Please try again.');
    }
  };

  // Add Course form handlers
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const validateForm = () => {
    if (!formData.courseId.trim()) {
      setError('Course ID is required');
      return false;
    }
    if (!formData.name.trim()) {
      setError('Course name is required');
      return false;
    }
    if (!formData.tool) {
      setError('Tool is required');
      return false;
    }
    return true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccessMessage('');

    if (!validateForm()) {
      return;
    }

    setIsSubmitting(true);
    try {
      const payload = {
        courseId: formData.courseId.trim(),
        name: formData.name.trim(),
        tool: formData.tool
      };

      if (formData.alias.trim()) payload.alias = formData.alias.trim();
      if (formData.externalId.trim()) payload.externalId = formData.externalId.trim();
      if (formData.stateCode) payload.stateCode = formData.stateCode;
      if (formData.url.trim()) payload.url = formData.url.trim();
      if (formData.bookingUrl.trim()) payload.bookingUrl = formData.bookingUrl.trim();
      if (formData.timezone) payload.timezone = formData.timezone;
      if (formData.affiliation.trim()) payload.affiliation = formData.affiliation.trim();

      await axiosInstance.post('/admin/courses', payload);

      setSuccessMessage(`Course "${formData.name}" added successfully!`);
      setFormData(initialFormState);
      setCurlInput('');
      setCurlError('');
      setCurlSuccess('');

      // Refresh courses list if on manage tab
      if (activeTab === 'manage') {
        fetchCourses();
      }
    } catch (err) {
      console.error('Error creating course:', err);
      setError(err.response?.data?.message || 'Failed to create course. Please try again.');
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleReset = () => {
    setFormData(initialFormState);
    setCurlInput('');
    setCurlError('');
    setCurlSuccess('');
    setError('');
    setSuccessMessage('');
  };

  // Get display value for edited or original course
  const getCourseValue = (course, field) => {
    if (editedCourses[course.courseId]) {
      return editedCourses[course.courseId][field] || '';
    }
    return course[field] || '';
  };

  return (
    <div className="admin-page">
      <header className="admin-header">
        <div className="header-content">
          <div className="header-logo">
            <img src={logo} alt="TeeserGolf" />
          </div>
          <Navigation />
        </div>
      </header>

      <main className="admin-main">
        <div className="admin-content">
          <h1>Admin Panel</h1>
          <p className="admin-subtitle">Manage courses and system settings</p>

          {/* Tab Navigation */}
          <div className="admin-tabs">
            <button
              className={`tab-button ${activeTab === 'manage' ? 'active' : ''}`}
              onClick={() => setActiveTab('manage')}
            >
              Manage Courses
            </button>
            <button
              className={`tab-button ${activeTab === 'add' ? 'active' : ''}`}
              onClick={() => setActiveTab('add')}
            >
              Add New Course
            </button>
          </div>

          {/* Manage Courses Tab */}
          {activeTab === 'manage' && (
            <div className="admin-section">
              <h2>Course Management</h2>
              <p className="section-description">
                View, filter, and edit existing courses. Click on a row to edit.
              </p>

              {coursesError && (
                <div className="error-message">{coursesError}</div>
              )}

              {coursesSuccess && (
                <div className="success-message">{coursesSuccess}</div>
              )}

              {/* Filters */}
              <div className="filters-section">
                <div className="filters-row">
                  <div className="filter-group">
                    <input
                      type="text"
                      name="search"
                      value={filters.search}
                      onChange={handleFilterChange}
                      placeholder="Search by name, ID, or alias..."
                      className="filter-input search-input"
                    />
                  </div>
                  <div className="filter-group">
                    <select
                      name="tool"
                      value={filters.tool}
                      onChange={handleFilterChange}
                      className="filter-select"
                    >
                      <option value="">All Tools</option>
                      {TOOL_OPTIONS.map(opt => (
                        <option key={opt.value} value={opt.value}>{opt.label}</option>
                      ))}
                    </select>
                  </div>
                  <div className="filter-group">
                    <select
                      name="stateCode"
                      value={filters.stateCode}
                      onChange={handleFilterChange}
                      className="filter-select"
                    >
                      <option value="">All States</option>
                      {STATE_OPTIONS.filter(s => s.value).map(opt => (
                        <option key={opt.value} value={opt.value}>{opt.label}</option>
                      ))}
                    </select>
                  </div>
                  <div className="filter-group">
                    <select
                      name="active"
                      value={filters.active}
                      onChange={handleFilterChange}
                      className="filter-select"
                    >
                      <option value="">All Status</option>
                      <option value="true">Active</option>
                      <option value="false">Inactive</option>
                    </select>
                  </div>
                  <button className="clear-filters-btn" onClick={clearFilters}>
                    Clear
                  </button>
                </div>
                <div className="filter-results">
                  Showing {filteredCourses.length} of {courses.length} courses
                </div>
              </div>

              {isLoadingCourses ? (
                <div className="loading-message">Loading courses...</div>
              ) : (
                <div className="courses-table-container">
                  <table className="courses-table">
                    <thead>
                      <tr>
                        <th>Status</th>
                        <th>Name</th>
                        <th>Tool</th>
                        <th>State</th>
                        <th>External ID</th>
                        <th>Timezone</th>
                        <th>Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {filteredCourses.map(course => (
                        <tr
                          key={course.courseId}
                          className={editingCourseId === course.courseId ? 'editing-row' : ''}
                        >
                          <td>
                            <button
                              className={`status-toggle ${course.active ? 'active' : 'inactive'}`}
                              onClick={() => toggleCourseActive(course)}
                              title={course.active ? 'Click to deactivate' : 'Click to activate'}
                            >
                              {course.active ? 'Active' : 'Inactive'}
                            </button>
                          </td>
                          <td>
                            {editingCourseId === course.courseId ? (
                              <input
                                type="text"
                                value={getCourseValue(course, 'name')}
                                onChange={(e) => handleEditChange(course.courseId, 'name', e.target.value)}
                                className="inline-edit-input"
                              />
                            ) : (
                              <div className="course-name-cell">
                                <span className="course-name">{course.name}</span>
                                {course.alias && (
                                  <span className="course-alias">({course.alias})</span>
                                )}
                              </div>
                            )}
                          </td>
                          <td>
                            {editingCourseId === course.courseId ? (
                              <select
                                value={getCourseValue(course, 'tool')}
                                onChange={(e) => handleEditChange(course.courseId, 'tool', e.target.value)}
                                className="inline-edit-select"
                              >
                                {TOOL_OPTIONS.map(opt => (
                                  <option key={opt.value} value={opt.value}>{opt.label}</option>
                                ))}
                              </select>
                            ) : (
                              <span className={`tool-badge tool-${course.tool}`}>
                                {TOOL_OPTIONS.find(t => t.value === course.tool)?.label || course.tool}
                              </span>
                            )}
                          </td>
                          <td>
                            {editingCourseId === course.courseId ? (
                              <select
                                value={getCourseValue(course, 'stateCode')}
                                onChange={(e) => handleEditChange(course.courseId, 'stateCode', e.target.value)}
                                className="inline-edit-select"
                              >
                                {STATE_OPTIONS.map(opt => (
                                  <option key={opt.value} value={opt.value}>{opt.label}</option>
                                ))}
                              </select>
                            ) : (
                              course.stateCode || '-'
                            )}
                          </td>
                          <td>
                            {editingCourseId === course.courseId ? (
                              <input
                                type="text"
                                value={getCourseValue(course, 'externalId')}
                                onChange={(e) => handleEditChange(course.courseId, 'externalId', e.target.value)}
                                className="inline-edit-input"
                                placeholder="External ID"
                              />
                            ) : (
                              course.externalId || '-'
                            )}
                          </td>
                          <td>
                            {editingCourseId === course.courseId ? (
                              <select
                                value={getCourseValue(course, 'timezone')}
                                onChange={(e) => handleEditChange(course.courseId, 'timezone', e.target.value)}
                                className="inline-edit-select"
                              >
                                {TIMEZONE_OPTIONS.map(opt => (
                                  <option key={opt.value} value={opt.value}>{opt.label}</option>
                                ))}
                              </select>
                            ) : (
                              course.timezone ? course.timezone.replace('America/', '').replace('Pacific/', '') : '-'
                            )}
                          </td>
                          <td>
                            {editingCourseId === course.courseId ? (
                              <div className="action-buttons">
                                <button
                                  className="save-btn"
                                  onClick={() => saveEdit(course.courseId)}
                                  disabled={savingCourseId === course.courseId}
                                >
                                  {savingCourseId === course.courseId ? 'Saving...' : 'Save'}
                                </button>
                                <button
                                  className="cancel-btn"
                                  onClick={() => cancelEditing(course.courseId)}
                                  disabled={savingCourseId === course.courseId}
                                >
                                  Cancel
                                </button>
                              </div>
                            ) : (
                              <button
                                className="edit-btn"
                                onClick={() => startEditing(course)}
                              >
                                Edit
                              </button>
                            )}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>

                  {filteredCourses.length === 0 && !isLoadingCourses && (
                    <div className="no-courses-message">
                      {courses.length === 0
                        ? 'No courses found. Add a course to get started.'
                        : 'No courses match your filters.'}
                    </div>
                  )}
                </div>
              )}
            </div>
          )}

          {/* Add Course Tab */}
          {activeTab === 'add' && (
            <div className="admin-section">
              <h2>Add New Course</h2>
              <p className="section-description">
                Add a new golf course to the database. Fields marked with * are required.
              </p>

              {error && (
                <div className="error-message">{error}</div>
              )}

              {successMessage && (
                <div className="success-message">{successMessage}</div>
              )}

              <form onSubmit={handleSubmit} className="course-form">
                <div className="form-section">
                  <h3>cURL Import</h3>
                  <p className="section-description">
                    Select a booking tool, then paste a cURL command to auto-fill fields below.
                  </p>

                  {curlError && <div className="error-message">{curlError}</div>}
                  {curlSuccess && <div className="success-message">{curlSuccess}</div>}

                  <div className="form-group">
                    <label htmlFor="curlInput">cURL Command</label>
                    <textarea
                      id="curlInput"
                      value={curlInput}
                      onChange={(e) => setCurlInput(e.target.value)}
                      placeholder={"curl 'https://...' \\\n  -H 'header: value' \\\n  --data-raw '{...}'"}
                      rows={5}
                      className="curl-textarea"
                      disabled={isSubmitting}
                    />
                  </div>
                  <button
                    type="button"
                    className="extract-btn"
                    onClick={handleCurlExtract}
                    disabled={isSubmitting}
                  >
                    Extract Fields
                  </button>
                </div>

                <div className="form-section">
                  <h3>Required Information</h3>

                  <div className="form-group">
                    <label htmlFor="courseId">Course ID *</label>
                    <input
                      type="text"
                      id="courseId"
                      name="courseId"
                      value={formData.courseId}
                      onChange={handleInputChange}
                      placeholder="Unique identifier (e.g., course-slug-123)"
                      disabled={isSubmitting}
                    />
                  </div>

                  <div className="form-group">
                    <label htmlFor="name">Course Name *</label>
                    <input
                      type="text"
                      id="name"
                      name="name"
                      value={formData.name}
                      onChange={handleInputChange}
                      placeholder="Full course name"
                      disabled={isSubmitting}
                    />
                  </div>

                  <div className="form-group">
                    <label htmlFor="tool">Booking Tool *</label>
                    <select
                      id="tool"
                      name="tool"
                      value={formData.tool}
                      onChange={handleInputChange}
                      disabled={isSubmitting}
                    >
                      <option value="">Select a booking tool</option>
                      {TOOL_OPTIONS.map(option => (
                        <option key={option.value} value={option.value}>
                          {option.label}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>

                <div className="form-section">
                  <h3>Optional Information</h3>

                  <div className="form-row">
                    <div className="form-group">
                      <label htmlFor="alias">Alias</label>
                      <input
                        type="text"
                        id="alias"
                        name="alias"
                        value={formData.alias}
                        onChange={handleInputChange}
                        placeholder="Alternative name"
                        disabled={isSubmitting}
                      />
                    </div>

                    <div className="form-group">
                      <label htmlFor="externalId">External ID</label>
                      <input
                        type="text"
                        id="externalId"
                        name="externalId"
                        value={formData.externalId}
                        onChange={handleInputChange}
                        placeholder="ID from booking system"
                        disabled={isSubmitting}
                      />
                    </div>
                  </div>

                  <div className="form-row">
                    <div className="form-group">
                      <label htmlFor="stateCode">State</label>
                      <select
                        id="stateCode"
                        name="stateCode"
                        value={formData.stateCode}
                        onChange={handleInputChange}
                        disabled={isSubmitting}
                      >
                        {STATE_OPTIONS.map(option => (
                          <option key={option.value} value={option.value}>
                            {option.label}
                          </option>
                        ))}
                      </select>
                    </div>

                    <div className="form-group">
                      <label htmlFor="timezone">Timezone</label>
                      <select
                        id="timezone"
                        name="timezone"
                        value={formData.timezone}
                        onChange={handleInputChange}
                        disabled={isSubmitting}
                      >
                        {TIMEZONE_OPTIONS.map(option => (
                          <option key={option.value} value={option.value}>
                            {option.label}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>

                  <div className="form-group">
                    <label htmlFor="url">API URL</label>
                    <input
                      type="url"
                      id="url"
                      name="url"
                      value={formData.url}
                      onChange={handleInputChange}
                      placeholder="https://api.example.com/tee-times"
                      disabled={isSubmitting}
                    />
                  </div>

                  <div className="form-group">
                    <label htmlFor="bookingUrl">Booking URL</label>
                    <input
                      type="url"
                      id="bookingUrl"
                      name="bookingUrl"
                      value={formData.bookingUrl}
                      onChange={handleInputChange}
                      placeholder="https://example.com/book"
                      disabled={isSubmitting}
                    />
                  </div>

                  <div className="form-group">
                    <label htmlFor="affiliation">Affiliation</label>
                    <input
                      type="text"
                      id="affiliation"
                      name="affiliation"
                      value={formData.affiliation}
                      onChange={handleInputChange}
                      placeholder="e.g., PGA, Municipal"
                      disabled={isSubmitting}
                    />
                  </div>
                </div>

                <div className="form-actions">
                  <button
                    type="submit"
                    className="submit-button"
                    disabled={isSubmitting}
                  >
                    {isSubmitting ? 'Adding Course...' : 'Add Course'}
                  </button>
                  <button
                    type="button"
                    className="reset-button"
                    onClick={handleReset}
                    disabled={isSubmitting}
                  >
                    Reset Form
                  </button>
                </div>
              </form>
            </div>
          )}
        </div>
      </main>
    </div>
  );
}

export default AdminPage;
